import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Лайтбокс для сертификатов с навигацией prev/next и клавиатурой.
 * Props:
 *  - images: string[] (массив URL)
 *  - index: number (текущий индекс)
 *  - onClose: () => void
 *  - onChange: (newIndex: number) => void
 *  - title: string (имя врача)
 */
export default function CertificateLightbox({ images, index, onClose, onChange, title }) {
  const total = images?.length || 0;

  const next = useCallback(() => {
    if (total) onChange((index + 1) % total);
  }, [index, total, onChange]);

  const prev = useCallback(() => {
    if (total) onChange((index - 1 + total) % total);
  }, [index, total, onChange]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [next, prev, onClose]);

  if (index < 0 || !images?.[index]) return null;

  return (
    <div className="lightbox-backdrop" onClick={onClose} data-testid="cert-lightbox">
      <div className="lightbox-toolbar">
        <div className="lightbox-title">
          {title}
          <span> · {index + 1} / {total}</span>
        </div>
        <button
          className="lightbox-close"
          onClick={onClose}
          aria-label="Закрыть"
          data-testid="cert-lightbox-close"
        >
          <X size={20} />
        </button>
      </div>

      <button
        className="lightbox-nav lightbox-prev"
        onClick={(e) => { e.stopPropagation(); prev(); }}
        aria-label="Предыдущий"
        data-testid="cert-prev"
        disabled={total < 2}
      >
        <ChevronLeft size={28} />
      </button>

      <div className="lightbox-image-wrap" onClick={(e) => e.stopPropagation()}>
        <img
          src={images[index]}
          alt={`Сертификат ${index + 1}`}
          className="lightbox-image"
        />
      </div>

      <button
        className="lightbox-nav lightbox-next"
        onClick={(e) => { e.stopPropagation(); next(); }}
        aria-label="Следующий"
        data-testid="cert-next"
        disabled={total < 2}
      >
        <ChevronRight size={28} />
      </button>
    </div>
  );
}
